import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { conditions } from "@/data/conditions";
import { cities } from "@/data/cities";
import rioMarkWhite from "@/assets/rio-mark-white.png.asset.json";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={rioMarkWhite.url}
                alt="Rio Med Care"
                width={44}
                height={44}
                className="h-11 w-11 object-contain"
              />
              <h3 className="text-2xl font-bold">Rio Med Care</h3>
            </div>
            <p className="text-background/80 mb-6 leading-relaxed">
              English-speaking medical care for international visitors and expatriates in Brazil. 
              Professional, accessible, and always available when you need us most.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center flex-wrap">
                <span className="font-medium">CRM-RJ:</span>
                <span className="ml-2">52-0115383-8</span>
                <a
                  href="https://portal.cfm.org.br/busca-medicos/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 underline hover:text-background"
                >
                  Verify
                </a>
              </div>
              <div className="text-background/60">Licensed Medical Practice in Brazil</div>
              <div className="text-background/60 italic mt-2">Rio Med Care does not sell or deliver medications.</div>
            </div>
          </div>

          {/* What We Treat */}
          <div>
            <h4 className="text-lg font-semibold mb-4">What We Treat</h4>
            <ul className="space-y-2 text-background/80 text-sm">
              {conditions.slice(0, 6).map((condition) => (
                <li key={condition.slug}>
                  <Link
                    to={`/what-we-treat/${condition.slug}`}
                    className="hover:text-background transition-colors"
                  >
                    {condition.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/what-we-treat" className="underline hover:text-background transition-colors">
                  View all conditions
                </Link>
              </li>
              <li>
                <Link to="/travel-insurance-reimbursement-brazil" className="underline hover:text-background transition-colors">
                  Travel insurance &amp; receipts
                </Link>
              </li>
            </ul>
            <h4 className="text-lg font-semibold mt-6 mb-3">Online in your city</h4>
            <ul className="space-y-2 text-background/80 text-sm">
              {cities.map((city) => (
                <li key={city.slug}>
                  <Link to={`/${city.slug}`} className="hover:text-background transition-colors">
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-background/80">
              <div className="flex items-center">
                <MessageCircle className="h-4 w-4 mr-3 flex-shrink-0" />
                <span>+55 21 99800-0676</span>
              </div>
              <div className="flex items-center">
                <Mail className="h-4 w-4 mr-3 flex-shrink-0" />
                <a href="mailto:riomedcare@gmail.com" className="hover:text-background transition-colors">riomedcare@gmail.com</a>
              </div>
              <div className="flex items-start">
                <MapPin className="h-4 w-4 mr-3 flex-shrink-0 mt-0.5" />
                <div>
                  <div>Online — throughout Brazil</div>
                </div>
              </div>
            </div>
          </div>

          {/* Hours & Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hours</h4>
            <div className="space-y-2 text-background/80 text-sm mb-6">
              <div className="flex justify-between">
                <span>Daily:</span>
                <span>7:00 - 22:00</span>
              </div>
            </div>
            
            <div className="text-xs text-background/60 space-y-1">
              <div>Registered Medical Practice</div>
              <div>Licensed in Brazil</div>
              <div>International Insurance Receipts</div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-background/60 text-sm mb-4 md:mb-0 space-y-1">
              <div>
                © {new Date().getFullYear()} Rio Med Care. All rights reserved. Medical services provided by licensed Brazilian physicians.
              </div>
              <div>
                Rio Med Care · Telemedicine Services · CRM-RJ 52-0115383-8 · Technical Director Dr. Luis Santos, MD
              </div>
              <div>Secure payments processed by Stripe · Card statement: RIOMEDCARE</div>
            </div>
            <div className="flex space-x-6 text-sm text-background/60">
              <Link to="/privacy" className="hover:text-background transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-background transition-colors">Terms of Service</Link>
              <Link to="/medical-disclaimer" className="hover:text-background transition-colors">Medical Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
